import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  SITE_NAME,
  SEO_PAGES,
  buildCanonical,
  buildOrganizationSchema,
  buildWebSiteSchema,
  buildWebPageSchema
} from './siteSeo';

const SeoHead = ({
  pageKey,
  title,
  description,
  keywords,
  ogImage,
  canonicalPath,
  robots = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
  schemas = [],
  noindex = false
}) => {
  const page = pageKey ? SEO_PAGES[pageKey] : null;
  const resolvedTitle = title || page?.title || SITE_NAME;
  const resolvedDescription = description || page?.description || '';
  const resolvedKeywords = keywords || page?.keywords || '';
  const resolvedPath = canonicalPath || page?.path || '/';
  const resolvedImage = ogImage || page?.ogImage;
  const canonical = buildCanonical(resolvedPath);

  const jsonLd = [
    buildOrganizationSchema(),
    buildWebSiteSchema(),
    pageKey ? buildWebPageSchema(pageKey) : null,
    ...schemas
  ].filter(Boolean);

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      {resolvedKeywords && <meta name="keywords" content={resolvedKeywords} />}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      {resolvedImage && <meta property="og:image" content={resolvedImage} />}
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      {resolvedImage && <meta name="twitter:image" content={resolvedImage} />}

      {jsonLd.map((schema, index) => (
        <script key={`schema-${index}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
